export { renderDivider_unstable as renderDivider } from '@fluentui/react-divider';
